// Shared Vuelidate rule fragments for registration/student forms. These mirror
// backend/app/Models/RegistrationFormSettings.php so public and dashboard forms
// stay aligned with server-side validation.

export function toEnglishDigitsStr(value) {
  if (!value) return value;
  return String(value).replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
}

export const trimmedMinLength = (min) => (value) => !value || String(value).trim().length >= min;

export const arabicOnly = (value) => !value || /^[ء-يـ\s]+$/.test(value);

export const exactDigits = (len) => (value) => {
  if (!value) return true;
  const digits = toEnglishDigitsStr(value);
  return /^\d+$/.test(digits) && digits.length === len;
};

export const startsWithZeroOne = (value) => {
  if (!value) return true;
  return toEnglishDigitsStr(String(value)).startsWith('01');
};

// parent_phone accepts either an Egyptian mobile or landline number — unlike
// exactDigits/startsWithZeroOne (student_phone/whatsapp_number: always mobile,
// exactly 11 digits, must start with "01"), only the digit-count range matters
// here. Mirrors the backend's digits_between:7,11 rule.
export const digitsBetween = (min, max) => (value) => {
  if (!value) return true;
  const digits = toEnglishDigitsStr(value);
  return /^\d+$/.test(digits) && digits.length >= min && digits.length <= max;
};

export const isNumericOrEmpty = (value) => {
  if (value === null || value === undefined || value === '') return true;
  return /^\d+(\.\d+)?$/.test(toEnglishDigitsStr(String(value)));
};

export const minValueOrEmpty = (min) => (value) => {
  if (value === null || value === undefined || value === '') return true;
  if (!isNumericOrEmpty(value)) return true;
  return Number(toEnglishDigitsStr(value)) >= min;
};

export const maxValueOrEmpty = (max) => (value) => {
  if (value === null || value === undefined || value === '') return true;
  if (!isNumericOrEmpty(value)) return true;
  return Number(toEnglishDigitsStr(value)) <= max;
};

export const notGreaterThan = (getOtherValue) => (value) => {
  if (value === null || value === undefined || value === '') return true;
  const other = getOtherValue();
  if (other === null || other === undefined || other === '' || !isNumericOrEmpty(other)) return true;
  if (!isNumericOrEmpty(value)) return true;
  return Number(toEnglishDigitsStr(value)) <= Number(toEnglishDigitsStr(other));
};

export function toEnglishDigits(value) {
  return value ? String(value).replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)) : value;
}
